export function delayOpen(url: string, target?: string) {
  setTimeout(() => {
    open(url, target)
  }, 600)
}
